import { FC } from "react";
import { GroupProps } from "react-select";

import { createComponentStyleHook } from "capitalrx-components-2.0/lib/tokens";
import classNames from "classnames";

import { OptionItem } from "../../OptionItem";

import tokenStyles from "./styles.module.css";
import legacyStyles from "./styles.module.scss";

const useResolvedDropdownGroupStyles = createComponentStyleHook<GroupProps<OptionItem | null>>({
  legacyStyles,
  tokenStyles,
  componentTokens: "dropdown_group",
});

/**
 * The group component.
 */
export const Group: FC<GroupProps<OptionItem | null>> = (props) => {
  const { children, Heading, label, headingProps } = props;
  const { mode, styles, StyleModeBoundary } = useResolvedDropdownGroupStyles(props);

  return (
    <StyleModeBoundary mode={mode}>
      <div className={classNames(styles.Group, "group")} role="group">
        <Heading {...props} {...headingProps}>
          {label}
        </Heading>
        {children}
      </div>
    </StyleModeBoundary>
  );
};
